module.exports = __webpack_public_path__ + "static/media/doodle.e10268e8.svg";